import { Routes, Route } from "react-router-dom";
import {ProtectedRoute} from "../protected-route";
import { Dashboard, Home, VideoLibrary, ExercisesTab, PlansTab, AccountManagement, PoolsManagement } from "../../pages";

export const AppRoutes = () => {
  return (
    <Routes>
   

      {/* Protected Routes */}

      <Route element={<ProtectedRoute allowedRoles={["system_admin", "account_admin"]} />}>
        <Route path="/home" element={<Home />} />
      </Route>
      
      <Route element={<ProtectedRoute allowedRoles={["system_admin", "account_admin"]} />}>
        <Route path="/accounts" element={<AccountManagement />} />
      </Route>

      <Route element={<ProtectedRoute allowedRoles={["system_admin", "training_librarian"]} />}>
        <Route path="/video-library" element={<VideoLibrary />}>
          <Route index element={<ExercisesTab />} />
          <Route path="plans" element={<PlansTab />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute allowedRoles={["system_admin"]} />}>
        <Route path="/pools-management" element={<PoolsManagement />} />
      </Route>

      <Route element={<ProtectedRoute allowedRoles={["system_admin"]} />}>
        <Route path="/" element={<Dashboard />} />
      </Route>
    </Routes>
  );
};

